import React from 'react';
import PropTypes from 'prop-types';
import '../../../stylesheets/pages/preauth/components/BrandGrid.less';


const BrandGrid = () => (
  <div className="brand-container text-center">
    <p className="text-uppercase press-heading">Zola in the Press</p>
    {/* mobile */}
    <div className="visible-xs visible-sm">
      <div className="row top-row">
        <div className="col-xs-12">
          <a href="https://www.brides.com/story/zola-wedding-planning-launch" target="_blank" rel="noopener noreferrer"><div className="brand col-xs-4 brides" /></a>
          <a href="https://www.nytimes.com/2017/09/22/nyregion/shan-lyn-ma-zola-wedding-registry-sunday-routine.html" target="_blank" rel="noopener noreferrer"><div className="brand col-xs-4 nyt" /></a>
          <a href="https://www.fastcompany.com/40406565/zola-story" target="_blank" rel="noopener noreferrer"><div className="brand col-xs-4 fast-company" /></a>
        </div>
      </div>
    </div>
    <div className="visible-xs visible-sm">
      <div className="row bottom-row">
        <div className="col-xs-12">
          <a href="https://www.today.com/video/what-to-put-on-your-wedding-registry-cuisinart-knives-and-more-1149352003887" target="_blank" rel="noopener noreferrer"><div className="brand col-xs-4 today" /></a>
          <a href="https://www.refinery29.com/2017/04/150410/zola-registry-wedding-website-launch" target="_blank" rel="noopener noreferrer"><div className="brand col-xs-4 refinery29" /></a>
          <a href="https://www.marthastewartweddings.com/624866/unique-wedding-registry-gift-ideas?slide=869925" target="_blank" rel="noopener noreferrer"><div className="brand col-xs-4 ms-weddings" /></a>
        </div>
      </div>
    </div>
    {/* desktop */}
    <div className="hidden-xs hidden-sm">
      <div className="row top-row">
        <div className="col-xs-12">
          <a href="https://www.brides.com/story/zola-wedding-planning-launch" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-3 col-lg-3 brides" /></a>

          <a href="https://www.nytimes.com/2017/09/22/nyregion/shan-lyn-ma-zola-wedding-registry-sunday-routine.html" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-2 nyt" /></a>

          <a href="https://www.fastcompany.com/40406565/zola-story" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-3 fast-company" /></a>

          <a href="http://www.instyle.com/weddings/best-registry-resource-zola" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-2 in-style" /></a>

          <a href="http://fortune.com/2017/04/18/zola-moves-to-take-over-wed-tech/" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs hidden-sm hidden-md col-lg-2 fortune" /></a>
        </div>
      </div>
    </div>
    <div className="hidden-xs hidden-sm bottom-row">
      <div className="row">
        <div className="col-xs-12">
          <a href="https://www.today.com/video/what-to-put-on-your-wedding-registry-cuisinart-knives-and-more-1149352003887" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-3 today" /></a>

          <a href="https://www.refinery29.com/2017/04/150410/zola-registry-wedding-website-launch" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-2 refinery29" /></a>

          <a href="https://www.marthastewartweddings.com/624866/unique-wedding-registry-gift-ideas?slide=869925" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-3 ms-weddings" /></a>

          <a href="http://www.businessinsider.com/best-online-wedding-registry-zola-overview-2017-2" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs col-sm-3 col-lg-2 business-insider" /></a>

          <a href="http://www.wsj.com/graphics/25-technology-companies-to-watch/" target="_blank" rel="noopener noreferrer"><div className="brand hidden-xs hidden-sm hidden-md col-lg-2 wsj" /></a>
        </div>
      </div>
    </div>
  </div>
);

BrandGrid.propTypes = {
  brands: PropTypes.shape({})
};


export default BrandGrid;



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/components/BrandGrid.jsx
 **/